var _defs, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 250,
    height: 30,
    viewBox: "5 0 250 30",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad",
    x1: "-50%",
    y1: "0%",
    x2: "150%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "10%",
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "15%",
    stopColor: "#FF7A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "25%",
    stopColor: "#FF8C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "35%",
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "45%",
    stopColor: "#FFC000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "bisque"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopColor: "#C8FF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "60%",
    stopColor: "#E6FF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "65%",
    stopColor: "#FFC000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "75%",
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85%",
    stopColor: "#FF7A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "90%",
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "x1",
    values: "-10%;100%",
    dur: "5s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "x2",
    values: "0%;150%",
    dur: "5s",
    repeatCount: "indefinite"
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: "50%",
    y: "50%",
    textAnchor: "middle",
    dominantBaseline: "middle",
    fontFamily: "'Ubuntu Mono', monospace",
    fontSize: 15,
    fill: "url(#grad)"
  }, "\r\n    Computing &amp; Software Engineer\r\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTest);
export default __webpack_public_path__ + "static/media/test.8a5e7f242bd9878bccaf4581c866a7d4.svg";
export { ForwardRef as ReactComponent };